import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  fetchTaskCountRoutine,
  fetchInvoicesRoutine,
  fetchPaymentSourceRoutine,
  updatePaymentSourceRoutine,
  cancelAccountRoutine,
  fetchAccountRoutine,
  upgradeAccountRoutine,
} from '../../../../redux/routines';
import Dashboard from '../../../Dashboard';
import {
  toJS
} from '../../../../utils/helper';
import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';

import styles from './styles';
import BillingGrid from '../BillingGrid';
import { CONFIRM_DIALOG, CREDIT_CARD_DIALOG, UPGRADE_DIALOG } from '../../../../redux/constants/dialogs';
import DataRetentionTile from './tiles/DataRetentionTile';
import PaymentSourceTile from './tiles/PaymentSourceTile';
import PlanTile from './tiles/PlanTile';
import TaskCountTile from './tiles/TaskCountTile';

class Billing extends Component {
  componentWillMount() {
    const { fetchAccount, account } = this.props;
    fetchAccount();

    if (account) {
      this.props.fetchTaskCount(account.id);
      this.props.fetchPaymentSource(account.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.account && !this.props.account) {
      nextProps.fetchTaskCount(nextProps.account.id);
      nextProps.fetchPaymentSource(nextProps.account.id);
    }
  }

  handleCancelAccount = () => {
    console.log('cancel');
    const { account, cancelAccount } = this.props;
    // cancelAccount(account);
    return new Promise((resolve, reject) => {
      this.props.showDialog(CONFIRM_DIALOG, {
        title: 'Are you sure you wish to cancel this account?',
        onConfirm: () => cancelAccount(account).then(resolve),
        onReject: reject,
        confirmColor: 'secondary',
      });
    });
  };

  // handleUpgrade = () => {
  //   console.log('handleUpgrade');
  //   // const { account, upgradeAccount } = this.props;
  //   // upgradeAccount(account);
  // };

  handleChangePaymentSource = () => {
    console.log('handleChangePaymentSource');
    // const { account, updatePaymentSource } = this.props;
    // updatePaymentSource(account);
  };

  render() {
    const { account, invoices, fetchInvoices, showDialog } = this.props;

    return (
      <Dashboard title="Billing">
        <div style={styles.wrapper}>
          <div style={styles.row}>
            <TaskCountTile data={account && account.taskCount ? account.taskCount : { count: -1 }}/>
            <PlanTile
              account={account}
              onCancelAccount={this.handleCancelAccount}
              onUpgrade={() => showDialog(UPGRADE_DIALOG)}
            />
            <DataRetentionTile account={account}/>
            <PaymentSourceTile account={account} onChangePaymentSource={() => showDialog(CREDIT_CARD_DIALOG)}/>
          </div>
          <BillingGrid data={invoices} fetch={fetchInvoices}/>
        </div>
      </Dashboard>
    );
  }
}

Billing.propTypes = {
  fetchInvoices: PropTypes.func.isRequired,
  invoices: PropTypes.object,
  account: PropTypes.object,

  currentUser: PropTypes.object,
  taskCount: PropTypes.number,
  fetchTaskCount: PropTypes.func.isRequired,
  paymentSource: PropTypes.object,
  fetchPaymentSource: PropTypes.func.isRequired,
  updatePaymentSource: PropTypes.func.isRequired,
  cancelAccount: PropTypes.func.isRequired,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUser: state.getIn(['authentication', 'user']),
    invoices: toJS(state.getIn(['accounts', 'invoices'])),
    account: toJS(state.getIn(['accounts', 'account'])),
    paymentSource: toJS(state.getIn(['accounts', 'account', 'paymentSource'])),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAccount: fetchAccountRoutine.trigger,
    fetchInvoices: fetchInvoicesRoutine.trigger,
    fetchTaskCount: fetchTaskCountRoutine.trigger,
    fetchPaymentSource: fetchPaymentSourceRoutine.trigger,
    updatePaymentSource: updatePaymentSourceRoutine.trigger,
    cancelAccount: cancelAccountRoutine.trigger,
    upgradeAccount: upgradeAccountRoutine.trigger,

    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Billing);



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/BillingView/index.js